<template>
  <div class="supply">
    
    <div class="system">
      <div class="big-title">
        <p>行业痛点</p>
        <div class="line"></div>
        <div class="desc">
          如何帮助用户更好的进行运动是重点，不论是极具专业性的运动工具还是有很强的娱乐性的运动工具都会是很好的选择
        </div>
      </div>
      <div class="system-box">
        <div class="system-item" v-for="item in systemArr" :key="item.id" >
          <img :src="item.img" alt="" />
          <div>
              <h5>{{ item.title }}</h5>
              <h6>{{ item.desc }}</h6>
          </div>
        </div>
      </div>
    </div>
    
    <div class="hard">
      <div class="big-title">
        <p>核心功能</p>
        <div class="line"></div>
        <div class="desc">
          针对用户推出针对性的核心功能和激励措施，增加用户参与感、成就感，同时享受更多乐趣。
        </div>
      </div>
      <div class="hard-box">
        <div class="hard-item" v-for="item in hardArr" :key="item.id">
          <img :src="item.img" alt="" />
          <h2>{{ item.title }}</h2>
        </div>
      </div>
    </div>
    <div class="modeValue">
      <div class="big-title">
        <p>多种应用模式</p>
        <div class="line"></div>
        <div class="desc">
          丰富多彩的应用模式，满足企业平台的不同需求
        </div>
      </div>
      <!-- <ul class="modeList">
        <li :class="{'modeActive' : modeIndex==0}" @click="modeIndex=0"><img src="../../static/images/solution/fitPlan2.png" alt=""/></li>
        <li :class="{'modeActive' : modeIndex==1}" @click="modeIndex=1">多用户商城联营模式</li>
        <li :class="{'modeActive' : modeIndex==2}" @click="modeIndex=2">多店商城招商模式</li>
        <li :class="{'modeActive' : modeIndex==3}" @click="modeIndex=3">多用户购物商城自营+招商模式</li>
      </ul> -->
      <div class="modeCont">
        <img src="../../static/images/solution/fitPlan14.jpg" alt="" />
        <div class="modeContText">
          <h5>全民运动</h5>
          <div class="line"></div>
          <div class="modeItro"><span>服务品牌</span> 惠州市文化广电旅游体育局</div>
          <div class="modeItro"><span>应用终端</span> 惠州市文化广电旅游体育局</div>
          <div class="modeItro"><span>项目简介</span> <i>线上全民健身运动会突出参与性，旨在号召市民带动家人、亲友积极参与体育运动，营造自觉锻炼、主动健身、追求健康的风尚。</i></div>
          <div class="btn"><button><h6 @click="jumpService">了解详情</h6></button></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //核心列表
      hardArr: [
        {
          id: 0,
          img: require("../../static/images/solution/fitPlan6.png"),
          title: "运动记录",
        },
        {
          id: 1,
          img: require("../../static/images/solution/fitPlan7.png"),
          title: "数据管理",
        },
        {
          id: 2,
          img: require("../../static/images/solution/fitPlan8.png"),
          title: "场地预约",
        },
        {
          id: 3,
          img: require("../../static/images/solution/fitPlan9.png"),
          title: "健康目标",
        },
        {
          id: 4,
          img: require("../../static/images/solution/fitPlan10.png"),
          title: "视频健身",
        },
        {
          id: 5,
          img: require("../../static/images/solution/fitPlan11.png"),
          title: "晒运动",
        },
        {
          id: 6,
          img: require("../../static/images/solution/fitPlan12.png"),
          title: "打卡运动",
        },
        {
          id: 7,
          img: require("../../static/images/solution/fitPlan13.png"),
          title: "互动社区",
        },
      ],
      //行业痛点数据
      systemArr: [
        {
          id: 0,
          title:'记录健康数据',
          desc: "可以全天候自动记录用户运动行为，支持步行、跑步、骑行等有氧运动的自动识别和热量计算，同时还能帮助用户自动生成每天的生活轨迹。",
          img: require("../../static/images/solution/fitPlan1.png"),
        },
        {
          id: 1,
          title:'鼓励运动，报备运动成果',
          desc: "由于现代人越来越缺乏运动，可通过线上的运动求赞或打卡的形式鼓励现代人运动。采用参加活动的形式，让用户拍摄或上传运动视频至平台，利用社交圈子求赞或打卡取得成就感",
          img: require("../../static/images/solution/fitPlan2.png"),
        },
        {
          id: 2,
          title:'打造互动的运动圈子',
          desc: "用户在健身过程中可能会产生疑问，为用户打造一个互动的社区圈子。一方面解决了用户运动过程中的疑问，促进了健身爱好者的交流；另一方面增加了用户对运动健身平台的使用密度。",
          img: require("../../static/images/solution/fitPlan3.png"),
        },
        {
          id: 3,
          title:'需要学习某项运动的人',
          desc: "目前通过在线方式是可以找到许多教练，但鱼龙混杂，水平参差不齐。用户可通过地理位置、价格、教练点评，筛选出适合自己的教练，无论是初级者需要入门训练，还是发烧友渴望强化技艺，都可以在系统中找到自己感兴趣的课程。",
          img: require("../../static/images/solution/fitPlan4.png"),
        },
        {
          id: 4,
          title:'预定场地',
          desc: "用户若想打网球先得解决场地问题，一些比较好的场地通常也需要缴会费，并且还很难预约的上，平台可通过集中采购，让用户只要在平台充值小额费用，便可以优惠的价格直接在线订场地，场地状况在平台中也一目了然。",
          img: require("../../static/images/solution/fitPlan5.png"),
        },
      ],
      modeIndex:0,//选中的模式
      //模式列表
      modeList:[
        {
          img:require("../../static/images/solution/mode1.png"),
          title:'多商城系统自营模式',
          cont:'企业平台建立线上B2B2C商城系统，整合多种自身渠道业务。通过会员、商品、订单、账务和仓储管理系统，对B2B2C商城线上线下多种渠道进行统一管理',
        },{
          img:require("../../static/images/solution/mode3.png"),
          title:'多用户商城联营模式',
          cont:'多个渠道供应商一起合作经营，以商品入库、统一仓储、统一物流的方式进入库联营。多用户商城平台企业通过供销或直销的方式，将供应商资源纳入多用户商城平台自营体系，建立多个自营店铺，多样化商品和服务种类，进行资源整合。',
        },{
          img:require("../../static/images/solution/mode4.png"),
          title:'多店商城招商模式',
          cont:'多店铺商城系统企业签约多个渠道供应商，通过会员、交易、平台和财务管理系统，对多店商城网站进行管理，多个渠道供应商，以签约加盟的方式，入驻B2B2C商城平台',
        },{
          img:require("../../static/images/solution/mode2.png"),
          title:'多用户购物商城自营+招商模式',
          cont:'B2B2C系统企业整合多个渠道业务，通过会员、商品、订单、财务和仓储管理系统，入驻商家可自行对商品订单等进行管理，定期与多用户商城平台进行账务结算',
        },
      ],
    };
    },
    methods:{
      //立即咨询
    jumpService() {
      this.$addConsult()
    },
  },
};
</script>

<style lang="stylus" scoped>
.supply {
  margin: 80px 0 80px;
}

.hard {
  width: 100%;
  text-align :center
  margin: 0 auto;
  padding-bottom: 80px;
  background: url('../../static/images/solution/tu2.png') no-repeat;
  background-size: cover;

  .big-title{
    p{
      font-size: 30px;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 28px;
      margin-top:80px;
    }
    .desc{
      font-size: 16px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 28px;
    }
  }
  .hard-box {
    display: flex;
    margin:0 auto ;
    width :1280px;
  }

  .hard-item {
    box-sizing: border-box;
    width: 160px;
    height: 175px;
    // background: #352E2C;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img{
      width :48px;
      height :48px;
      margin :43px 0 25px 0
    }
    h2 {
      font-size: 16px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 28px;
    }

  }
}

 .modeValue {
  width: 1400px;
  margin: 81px auto;
}
.modeList{
  display :flex ;
  justify-content :center
  align-items :center
  li{
    // width: 192px;
    padding:0 20px;
    height: 46px;
    font-size: 16px;
    font-weight: 400;
    color: #666666;
    line-height: 46px;
    text-align :center
    margin :0 40px 
  }
  .modeActive{
    background: #FFC000;
    border-radius: 23px;
    color: #FFFFFF;
  }
}
.modeCont{
  display :flex;
  justify-content :center
  margin:27px;
  img{
    width :680px;
    height :490px;
  }
  .modeContText{
    width:649px;
    text-align :left;
    margin :38px 0 0 64px
    h5{
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      line-height: 24px;
    }
    p{
      font-size: 16px;
      font-weight: 400;
      color: #666666;
      line-height: 32px;
      margin:39px 0
    }
    .btn {
      margin-top: 25px;
    }
    button {
      border: none;
    }
    h6{
      width: 100px;
      height: 40px;
      background: #FFC000;
      border-radius: 4px;
      line-height :40px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 28px;
      text-align :center
      line-height :40px
    }
  }
}
.modeItro{
  display :flex;
  justify-content :flex-start;
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  line-height: 28px;
  margin :30px 0 0 0
  span{
    width :70px
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 28px;
    margin:0 42px 0 0 
  }
  i{
    list-style :none
    width :543px
  }
}

.system {
  width: 1400px;
  margin: 0 auto;
  padding-bottom: 80px;

  .system-box {
    display: flex;
    flex-wrap: wrap;
    justify-content :space-between
  }
  .system-item:last-child, .system-item:nth-last-child(2){
    
    width: 688px;
  } 
  .system-item {
    width: 451px;
    // height: 132px;
    padding :42px 40px;
    background: #FFFFFF;
    box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
    border-radius: 4px;
    margin-bottom: 24px;
    text-align :center
    img{
      width :58px;
      height :58px
      margin:40px 0 24px 0
    }

    h5{
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      line-height: 28px;
      margin :0 0 32px 0
    }
    h6{
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 28px;
    }
  }

  .system-item:hover {
    box-shadow: 0px 5px 17px 3px rgba(230, 192, 76, 0.15);
  }
}

 .line {
    width: 42px;
    height: 2px;
    background: #FFC000;
    border-radius: 1px;
    margin-top: 29px;
  }
.big-title {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;

  p {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
  }

 

  .desc {
    font-size: 16px;
    font-weight: 400;
    color: #333;
    text-align: center;
    margin: 22px 0 50px;
    line-height: 28px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/solutionFitPlan.vue